import { logEvent } from "~/utils/firebase";

export function useAppDownloadModal() {
	const showAppDownloadModal = useState("showAppDownloadModal", () => false);
	const hideAppDownloadModalTitle = useState("hideAppDownloadModalTitle", () => false);

	const openAppDownloadModal = (options = {}) => {
		if (!import.meta.client) return;
		hideAppDownloadModalTitle.value = options.hideTitle === true;
		showAppDownloadModal.value = true;
		logEvent("site_download_show");
	};

	const closeAppDownloadModal = () => {
		showAppDownloadModal.value = false;
		hideAppDownloadModalTitle.value = false;
	};

	return {
		showAppDownloadModal,
		hideAppDownloadModalTitle,
		openAppDownloadModal,
		closeAppDownloadModal,
	};
}
